import isNumber from "lodash/isNumber";

export const formatPriceUptoTwoDecimal = (price) => {
    if (isNumber(price) && price > 0) {
        return `$${parseFloat(price).toFixed(2)}`;
    }
    return "FREE";
};